app.controller('programDetail', function ($scope, $document, $log, breakpointsService, loginService, $http) {
    window.onpopstate = function () {
        $scope.$apply(function () {
            $scope.programDetail.isFullscreen = false;
        });
    };

    $scope.isPremiumUser = false;

    $scope.programDetail = {
        isAddedToProfile: false,
        isFullscreen: false,
        sessionProgram: {
            time: 0,
            done: false
        },
        sessionExercises : [],
        pastSessionExercises : [],
        exerciseItemsById: {},
        getTodaysSessionRecord : function(exerciseItemId) {
            return this.sessionExercises.find(function(record) {
                return record.exerciseItemId === exerciseItemId;
            }) || {};
        },
        getExerciseItem: function(exerciseItemId) {
            return this.exerciseItemsById[exerciseItemId] || {};
        },
        isDone : function(exerciseItemId) {
            return !!this.getTodaysSessionRecord(exerciseItemId).done;
        },
        getDayExerciseItems : function(weekNr, dayNr) {
            if (this.exercisesByWeekAndDay[weekNr] && this.exercisesByWeekAndDay[weekNr][dayNr]) {
                return this.exercisesByWeekAndDay[weekNr][dayNr];
            }

            return [];
        },
        isWholeDayDone : function(weekNr, dayNr) {
            const dayExercises = this.getDayExerciseItems(weekNr, dayNr);

            if (dayExercises) {
                const doneCount = dayExercises.reduce(function (_doneCount, exerciseItem) {
                    return _doneCount + (this.isDone(exerciseItem.id) ? 1 : 0);
                }.bind(this), 0);

                return doneCount === dayExercises.length;
            }

            return false;
        },
        isDoneAndHasWeight: function(exerciseItemId) {
            return this.isDone(exerciseItemId) && this.getTodaysSessionRecord(exerciseItemId).weight;
        },
        getLastWeight: function(exerciseItemId, weightUnit) {
            let sessionRecord = this.getTodaysSessionRecord(exerciseItemId);

            if (!sessionRecord.done && !sessionRecord.weight && this.pastSessionExercises.length) {
                // Find the latest entry with weight
                sessionRecord = this.pastSessionExercises.find(function(el) {
                    return (el.exerciseItemId === exerciseItemId && el.weight > 0);
                });
            }

            if (sessionRecord && sessionRecord.id && sessionRecord.weight) {
                if (weightUnit && weightUnit.toLowerCase() === 'lb') {
                    return Math.round(sessionRecord.weight * 2.20462 * 100) / 100;
                } else {
                    return Math.round(sessionRecord.weight * 100) / 100;
                }
            }

            return '';
        },
        exercisesByWeekAndDay: [],
        weeksData: [],
        tpl: {
            weeks: "",
            days: ""
        },
        slick: {
            currentIndex: {
                weeks: 0,
                days: 0
            },
            weekCarouselItems: [],
            daysCarouselItems: [],
            weeksConfig: {
                event: {
                    afterChange: function (event, slick, currentSlide, nextSlide) {
                        $scope.programDetail.slick.currentIndex.weeks = currentSlide;
                    },
                    init: function (event, slick) {
                        slick.slickGoTo($scope.programDetail.slick.currentIndex.weeks); // slide to correct index when init
                    }
                },
                method: {}
            },
            daysConfig: {
                event: {
                    afterChange: function (event, slick, currentSlide, nextSlide) {
                        $scope.programDetail.slick.currentIndex.days = currentSlide;
                    },
                    init: function (event, slick) {
                        slick.slickGoTo($scope.programDetail.slick.currentIndex.days); // slide to correct index when init
                    }
                },
                method: {}
            }
        },
        openFullscreen: function () {
            $scope.programDetail.slick.currentIndex.weeks = 0;
            $scope.programDetail.slick.currentIndex.days = 0;
            $scope.programDetail.openToCard = 0;
            $scope.programDetail.isFullscreen = true;
        },
        openExerciseFullscreen: function (event, weekNum, dayNum, cardNumber) {
            // If clicking on a link, like the more details link, do not open the fullscreen
            if (event.target) {
                var $target = angular.element(event.target);

                if ($target.is('a') || $target.parents('a:first').length) {
                    return false;
                }
            }

            if ("pushState" in history) {
                history.pushState({fullscreen: true}, null, "?fs=1");
            }
            $scope.programDetail.openToCard = cardNumber - 1;
            $scope.programDetail.slick.currentIndex.weeks = weekNum - 1;
            $scope.programDetail.slick.currentIndex.days = dayNum - 1;
            $scope.programDetail.isFullscreen = true;
        },
        openToCard: 0,
        breakpoint: breakpointsService
    };

    $scope.setIsAddedToProfile = function(newValue) {
        $scope.programDetail.isAddedToProfile = newValue;
    };

    $scope.isProgramSessionEnabled = function() {
        return $scope.isPremiumUser && $scope.programDetail.isAddedToProfile;
    };

    $scope.handleSessionTimerPause = function(timeElapsed, perceivedExertion) {
        $scope.perceivedExertion = perceivedExertion;
        $scope.sessiontime = formatTime(timeElapsed, true);
        $scope.handleSessionFinishSubmitted(true);
    };

    $scope.handleSessionFinishDialog = function(timeElapsed, perceivedExertion) {
        const modal = angular.element("#sgCompleteProgramModal");
        modal.modal();

        $scope.perceivedExertion = perceivedExertion;
        $scope.sessiontime = formatTime(timeElapsed, true);
        jQuery('.jquery-timepicker').timepicker({
            timeFormat: 'HH:mm:ss',
            interval: 60,
            minTime: '00:00:00',
            maxTime: '23:59:59',
            defaultTime: $scope.sessiontime,
            startTime: '00:00:00',
            dynamic: false,
            dropdown: false,
            scrollbar: true
        });
    };

    $scope.handleSessionFinishSubmitted = function(isIntermediate) {
        const isDone = !isIntermediate;
        return $http({
            method: 'POST',
            url: '/_endpoint/profile/complete/program',
            data: {
                programId: $scope.programDetail.programId,
                time: $scope.sessiontime,
                exertion: $scope.perceivedExertion,
                done: isDone
            },
            responseType: 'json',
        }).then(function (httpResponse) {
            $scope.programDetail.sessionProgram = httpResponse.data;
            if (!isIntermediate) {
                const modal = angular.element("#sgCompleteProgramModal");
                modal.modal('hide');
            }
        }).catch(function(httpError) {
            if (httpError.xhrStatus !== "abort") {
                $log.error(httpError);
            }
            if (httpError.status === 403) {
                if (loginService.isLoggedIn === false) {
                    loginService.redirectToLoginScreen(true);
                } else if (httpError.headers('x-profile-upgrade-url')) {
                    window.location.href = httpError.headers('x-profile-upgrade-url');
                }
            }

            throw new Error('An error occurred! Please try again later.');
        });
    };

    $scope.$watch('programDetail.isFullscreen', function (newValue) {
        $scope.UI.disableBodyScroll = newValue;
    });

    $scope.$watch('programDetail.weeksData', function (newValue) {
        var slickData = $scope.programDetail.slick;

        var weekItems = [];
        for (var i = 0; i < newValue.length; i++) {
            weekItems.push($scope.programDetail.tpl.weeks.replace("%num%", i + 1));
        }

        slickData.weekCarouselItems = weekItems;
        slickData.currentIndex.weeks = 0;
    });

    $scope.$watch('programDetail.slick.currentIndex.weeks', function (newValue) {
        var numberOfDays = $scope.programDetail.weeksData[newValue];
        var slickData = $scope.programDetail.slick;

        if (typeof numberOfDays !== 'undefined') {
            var daysItems = [];
            for (var i = 0; i < numberOfDays; i++) {
                daysItems.push($scope.programDetail.tpl.days.replace("%num%", i + 1));
            }
            slickData.daysCarouselItems = daysItems;
        } else {
            slickData.daysCarouselItems = [];
        }

        slickData.currentIndex.days = 0;

        if (slickData.daysConfig.method.slickCurrentSlide && slickData.weeksConfig.method.slickCurrentSlide() !== newValue) {
            slickData.weeksConfig.method.slickGoTo(newValue);
        }
    });

    $scope.$watch('programDetail.slick.currentIndex.days', function (newValue) {
        var slickData = $scope.programDetail.slick;

        if (slickData.daysConfig.method.slickCurrentSlide && slickData.daysConfig.method.slickCurrentSlide() !== newValue) {
            slickData.daysConfig.method.slickGoTo(newValue);
        }
    });

    if (isMobile.phone && !loginService.isLoggedIn) {
        loginService.redirectToLoginScreen(true, ['progmobredir=1']);
    }
});
